@if ((label.renderType ?? label.labelDefinition?.renderType) === 'COLOR') {
  <span
    class="label-color-dot"
    [style.--chip-bg]="label.color || '#6b7280'"
    [matTooltip]="label.name">
  </span>
} @else {
  <cm-ui-chip
    class="label-tag"
    size="sm"
    [label]="label.name"
    [color]="label.color"
    [textColor]="label.color ? label.textColor : null"
  />
}
